// SettingsPage: Staff settings
import React from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import { Box, Typography, TextField, Button } from '@mui/material';

function SettingsPage() {
  return (
    <StaffLayout>
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 8 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>Settings</Typography>
        <form>
          <TextField label="Display Name" fullWidth sx={{ mb: 2 }} />
          <TextField label="Contact Email" fullWidth sx={{ mb: 2 }} />
          <Button variant="contained" color="primary">Save Settings</Button>
        </form>
      </Box>
    </StaffLayout>
  );
}

export default SettingsPage;
